import { getDiffRouteTime, report, stReportSdk } from './report';

stReportSdk.trackPageLoad();

report({
  eventName: 'load_page_start',
  eventDescription: '页面加载(默认上报，进入页面就上报)',
  eventDataValue: {
    td_pl: getDiffRouteTime()
  }
});
